import { Rate } from "antd";
import React, { useState } from "react";

const StarRate = ({ data }) => {
  return (
    <div>
      {" "}
      <Rate
        style={{
          width: "100%",
          fontSize: "30px",
          display: "flex",
          justifyContent: "space-evenly",
        }}
        disabled
        value={Number(data.answer) ? Number(data.answer) : 0}
      />
    </div>
  );
};

export default StarRate;
